export class HeartbeatLogger {
    constructor(wallet, debug) {
        this.wallet = wallet;
        this.debug = debug;
    }
    logStartingConnection(context) {
        this.__logWithPrefix(`Starting new connection...`, context);
    }
    logCheckingWallet(context) {
        this.__logWithPrefix(`Checking wallet...`, context);
    }
    logOperationAborted(context) {
        this.__logWithPrefix(`Operation aborted.`, context);
    }
    logNoWalletSet(context) {
        this.__logWithPrefix(`No wallet connected, aborting.`, context);
    }
    logNoApi(context) {
        this.__logWithPrefix(`No API found, aborting.`, context);
    }
    logNoWalletInWindow(context) {
        this.__logWithPrefix(`${this.wallet.includes("p2p")
            ? `Waiting for ${this.wallet} to exist on the window object.`
            : `${this.wallet} is selected, but does not exist on the window object.`}`, context);
    }
    logDoneWithChanges(context) {
        this.__logWithPrefix("Done with changes made to state.", context);
    }
    logDoneWithoutChanges(context) {
        this.__logWithPrefix("Done without any changes to state.", context);
    }
    __logWithPrefix(msg, context) {
        this.debug &&
            console.log(`HeartbeatLogger: ${msg} ${context ? `-- (context: ${context})` : ``}`);
    }
}
//# sourceMappingURL=HeartbeatLogger.js.map